import {useQuery, UseQueryResult} from "react-query";
import {getCompteurTempsDateDate} from "./compteurTempsDateDate.services";


export const useGetCompteurTempsDateDate = (dateFrom:string, dateTo:string, users:number[], idCentre:number|null=null):UseQueryResult<CompteurTempsDateDate[], Error>=>{
    return useQuery(["cpt_tps_dd", dateFrom, dateTo, users, idCentre], ({signal})=>getCompteurTempsDateDate(dateFrom, dateTo, users, signal, idCentre), {
        enabled:dateFrom!=='' && dateTo!=='' && users.length>0 && Array.isArray(users) && users[0]!==0,
        refetchOnWindowFocus:false,
    })
}